import { render } from "./MainHeaderComp.vue?vue&type=template&id=5607bd4e&scoped=true&ts=true"
import script from "./MainHeaderComp.vue?vue&type=script&lang=ts"
export * from "./MainHeaderComp.vue?vue&type=script&lang=ts"

import "./MainHeaderComp.vue?vue&type=style&index=0&id=5607bd4e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Documents\\Code\\VSProjects\\modboxProject\\modbox\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5607bd4e"]])

export default __exports__